import { onDomReady } from './on-dom-ready.js';

let bound = false;

function isNumberInput(target) {
    return target instanceof HTMLInputElement && target.type === 'number';
}

export function disableNativeNumberInputStep() {
    if (bound) {
        return;
    }
    bound = true;
    document.addEventListener('wheel', function (event) {
        const target = event.target;
        if (!isNumberInput(target)) {
            return;
        }
        if (document.activeElement !== target) {
            return;
        }
        event.preventDefault();
    }, { passive: false });
    document.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown') {
            return;
        }
        if (!isNumberInput(event.target)) {
            return;
        }
        event.preventDefault();
    });
}

onDomReady(disableNativeNumberInputStep);
